<template>
<vx-card title="Agendamiento">
    <vs-table pagination max-items="10" stripe search :data="meetings">
        <template slot="thead">
            <vs-th sort-key="website"> </vs-th>
            <vs-th sort-key="website">Nombres</vs-th>
            <vs-th sort-key="username">Teléfono</vs-th>
            <vs-th sort-key="email">Fecha</vs-th>
            <vs-th sort-key="website">Grabación</vs-th>
            <vs-th sort-key="id"></vs-th>
        </template>

        <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                    <vs-avatar :text="tr.client.client_nombres+' '+tr.client.client_apellidos" />
                </vs-td>

                <vs-td :data="tr.client.client_nombres">
                    {{ tr.client.client_nombres }} {{ tr.client.client_apellidos }}
                </vs-td>

                <vs-td :data="tr.client.client_phone">
                    {{ tr.client.client_phone }}
                </vs-td>

                <vs-td :data="tr.meet_start_date">
                    {{ tr.meet_start_date }}
                </vs-td>

                <vs-td :data="tr.meet_status">
                    <vs-chip v-if="tr.meet_status == 1" transparent color="success">
                        Aprobado
                    </vs-chip>
                    <vs-chip v-if="tr.meet_status == 0" transparent color="warning">
                        Pendiente
                    </vs-chip>
                </vs-td>
                <vs-td>
                    <vs-button size="small" class="rounded-full" color="success" @click="meeting_call(tr.meet_access_token)">Detalle</vs-button>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</vx-card>
</template>

<script>
import buttonSfx from '@/assets/sound/notify.mp3';
import meetings from "../services/meeting";
export default {
    data() {
        return {
            selected: [],
            meetings: [],
        };
    },
    components: {},

    mounted() {
        let me = this
        this.getMeetings();
        let channel = this.$pusher.subscribe('dashboard-channel');
        channel.bind('App\\Events\\Dashboard', function (data) {
            me.playSound('https://pttest.utim.us/notify.ogg');
            me.$vs.notify({
                color: 'success',
                title: 'Cliente nuevo',
                text: 'Agregado a la lista'
            })
            me.meetings.unshift(data)
        });
    },
    methods: {
        async getMeetings() {
            try {
                let {
                    data
                } = await meetings();
                this.meetings = data;
            } catch (error) {
                console.log(error);
            }
        },
        meeting_call(token) {
            localStorage._token_access = token
            var menu = {
                list: false,
                info: true
            }
            this.$emit('item',menu)
        },
        addMeeting(data) {
            console.log(JSON.parse(data))
        },
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        }
    },
};
</script>
